/**
 * Environment Variable Validator for Frontend
 * Ensures all required environment variables are present at startup
 * No fallback values - strict validation
 */

const validateEnv = () => {
  const errors = [];
  const warnings = [];

  // console.log('\n' + '='.repeat(70));
  // console.log('ENVIRONMENT VARIABLES VALIDATION');
  // console.log('='.repeat(70));

  // REQUIRED: REACT_APP_API_URL
  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl || apiUrl.trim() === '') {
    errors.push('REACT_APP_API_URL is REQUIRED but not set');
    // console.log('  ✗ REACT_APP_API_URL: MISSING');
  } else if (apiUrl === 'http://localhost:5001') {
    // console.log(`  ✓ REACT_APP_API_URL: ${apiUrl} (Development)`);
  } else {
    // console.log(`  ✓ REACT_APP_API_URL: ${apiUrl}`);
  }

  // OPTIONAL: REACT_APP_GA_ID (Google Analytics)
  const gaId = process.env.REACT_APP_GA_ID;
  if (gaId) {
    // console.log(`  ✓ REACT_APP_GA_ID: Configured`);
  } else {
    // console.log(`  ✗ REACT_APP_GA_ID: Not configured`);
  }

  // OPTIONAL: REACT_APP_ENVIRONMENT
  // const env = process.env.REACT_APP_ENVIRONMENT;
  // console.log(`  ℹ️  REACT_APP_ENVIRONMENT: ${env || 'not set'}`);

  // console.log('='.repeat(70));

  if (errors.length > 0) {
    // console.error('\n❌ VALIDATION FAILED - REQUIRED VARIABLES MISSING:\n');
    // errors.forEach(err => console.error(`  • ${err}`));
    throw new Error(
      'Frontend environment validation failed. ' +
      'Please set REACT_APP_API_URL in your .env file'
    );
  }

  if (warnings.length > 0) {
    // console.warn('\n⚠️  WARNINGS:\n');
    // warnings.forEach(warn => console.warn(`  • ${warn}`));
  }

  // console.log('✓ Environment validation passed\n');
};

// Run validation on module load
try {
  validateEnv();
} catch (error) {
  // console.error(error.message);
  // Don't throw in test environment
  if (process.env.NODE_ENV !== 'test') {
    // In development, warn but continue; in production, fail fast
    if (process.env.NODE_ENV === 'production') {
      throw error;
    }
  }
}

/**
 * Get required API URL (throws if not set)
 */
export const getApiUrl = () => {
  const url = process.env.REACT_APP_API_URL;
  if (!url || url.trim() === '') {
    throw new Error(
      'REACT_APP_API_URL environment variable is not set. ' +
      'Please configure it in your .env file.'
    );
  }
  return url;
};

/**
 * Get optional values with null return
 */
export const getOptionalEnv = (key) => {
  const value = process.env[key];
  return value && value.trim() !== '' ? value : null;
};

const envValidator = {
  getApiUrl,
  getOptionalEnv,
};

export default envValidator;
